import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AccordionModule } from 'primeng/primeng';
import { AutoCompleteModule } from 'primeng/primeng';
import { BlockUIModule } from 'primeng/primeng';
import { BreadcrumbModule } from 'primeng/primeng';
import { ButtonModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { CarouselModule } from 'primeng/primeng';
import { ChartModule } from 'primeng/primeng';
import { CheckboxModule } from 'primeng/primeng';
import { CodeHighlighterModule } from 'primeng/primeng';
import { ContextMenuModule } from 'primeng/primeng';
import { DataGridModule } from 'primeng/primeng';
import { DataListModule } from 'primeng/primeng';
import { DataScrollerModule } from 'primeng/primeng';
import { DataTableModule } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { DragDropModule } from 'primeng/primeng';
import { DropdownModule } from 'primeng/primeng';
import { EditorModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { FileUploadModule } from 'primeng/primeng';
import { GalleriaModule } from 'primeng/primeng';
import { GMapModule } from 'primeng/primeng';
import { GrowlModule } from 'primeng/primeng';
import { InplaceModule } from 'primeng/primeng';
import { InputMaskModule } from 'primeng/primeng';
import { InputSwitchModule } from 'primeng/primeng';
import { InputTextModule } from 'primeng/primeng';
import { InputTextareaModule } from 'primeng/primeng';
import { LightboxModule } from 'primeng/primeng';
import { ListboxModule } from 'primeng/primeng';
import { MegaMenuModule } from 'primeng/primeng';
import { MenuModule } from 'primeng/primeng';
import { MenubarModule } from 'primeng/primeng';
import { MessagesModule } from 'primeng/primeng';
import { MultiSelectModule } from 'primeng/primeng';
import { OrderListModule } from 'primeng/primeng';
import { OverlayPanelModule } from 'primeng/primeng';
import { PaginatorModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/primeng';
import { PanelMenuModule } from 'primeng/primeng';
import { PasswordModule } from 'primeng/primeng';
import { PickListModule } from 'primeng/primeng';
import { ProgressBarModule } from 'primeng/primeng';
import { RadioButtonModule } from 'primeng/primeng';
import { RatingModule } from 'primeng/primeng';
import { ScheduleModule } from 'primeng/primeng';
import { SelectButtonModule } from 'primeng/primeng';
import { SlideMenuModule } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { SpinnerModule } from 'primeng/primeng';
import { SplitButtonModule } from 'primeng/primeng';
import { StepsModule } from 'primeng/primeng';
import { TabMenuModule } from 'primeng/primeng';
import { TabViewModule } from 'primeng/primeng';
import { TerminalModule } from 'primeng/primeng';
import { TieredMenuModule } from 'primeng/primeng';
import { ToggleButtonModule } from 'primeng/primeng';
import { ToolbarModule } from 'primeng/primeng';
import { TooltipModule } from 'primeng/primeng';
import { TreeModule } from 'primeng/primeng';
import { TreeTableModule } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/primeng';

import { ConfirmDialogModule } from 'primeng/primeng';
import { SharedModule as PrimeNGSharedModule } from 'primeng/primeng';


import { BusyModule } from 'angular2-busy/index';
import { Ng2CompleterModule } from "ng2-completer";
import { CUIAutoCompleteComponent } from './cui-autocomplete/cui-autocomplete.component';
import { CUIDetailComponent, CUIDetailHeader } from './cui-detail/cui-detail.component';
import { CUIDialogComponent } from './cui-dialog/cui-dialog.component';
import { CUIConfirmDialogComponent } from './cui-confirm-dialog/cui-confirm-dialog.component';
import { CUIGridComponent } from './cui-grid/cui-grid.component';
import { CUIRowGroupComponent, CUIRowGroupHeaderComponent } from './cui-rowgroup/cui-rowgroup.component';
import { CUISearchListComponent } from './cui-search-list/cui-search-list.component';
import { CUISpinnerComponent } from './cui-spinner/cui-spinner.component';
import { CUITabViewComponent, CUITabMenuComponent, CUITabComponent, CUITabHeader, CUITabContent } from './cui-tabview/cui-tabview.component';
import { CUIEmptyComponent } from './cui-empty/cui-empty.component'; //YH 12/1/2016 Task 9542:Revamp Hydrogen Portal left hand side vertical

import { FormatterService, FormatDatePipe } from './formatter.service';

//YH 12/28/2016 Task 9829:Hydrogen Portal - User Management: Add/Remove User from Customer UI
import { CUIDynamicFormComponent } from './cui-dynamic-form/dynamic-form.component';
import { CUIDynamicFormQuestionComponent } from './cui-dynamic-form/dynamic-form-question.component';
import { CUIDynamicFormQuestionControlService } from './cui-dynamic-form/question-control.service';

import { CUIGridRowActionComponent } from './cui-grid-row-action/cui-grid-row-action.component';

import { CUIDeviceSettingsComponent } from './cui-device-settings/cui-device-settings.component';
import { CUISingularSettingComponent } from './cui-singular-setting/cui-singular-setting.component';


//Authorization
import { AuthorizationModule } from '../authorization/authorization.module';

import {CUICommunicationServiceInterface} from '../interfaces/cui-communication-service.interface';

import { PowerBiReportContainerComponent } from '../features/dashboard/powerbi-report-container/powerbi-report-container.component';
import { WorldViewContainerComponent } from '../features/dashboard/world-view-container/world-view-container.component';

 import { ActivityLogApiService } from '../services/Crestron.HydrogenAPI.ActivityLogApi.service';


import {DevicePropertyType } from  '../models/device-data-models/device-property-type.model';
import {DeviceControlEventModel } from    '../models/device-data-models/device-control-event.model';
import {DeviceControlActionType } from  '../models/device-data-models/device-control-action-type.model';
import {DeviceFormControlModel  } from  '../models/device-data-models/device-form-control.model';
import {DeviceControlType } from  '../models/device-data-models/device-control-type.model';
import {DeviceControlModel } from  '../models/device-data-models/device-control.model';
import {DeviceCategoryModel } from  '../models/device-data-models/device-category.model';
import { DeviceCategoryCollectionModel } from '../models/device-data-models/device-category-collection.model';
import { ScheduledActionsApiService } from '../services/Crestron.HydrogenAPI.ScheduledActionsApi.service';

import { TableModule } from 'primeng/table';
import { CuiTurboTableComponent } from '../shared/cui-turbo-table/cui-turbo-table.component';

@NgModule({
    imports: [

        AuthorizationModule,
        CommonModule,//Start Angular section
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        AccordionModule,
        AutoCompleteModule,
        BlockUIModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CarouselModule,
        ChartModule,
        CheckboxModule,
        CodeHighlighterModule,
        ContextMenuModule,
        DataGridModule,
        DataListModule,
        DataScrollerModule,
        DataTableModule,
        DialogModule,
        DragDropModule,
        DropdownModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        GalleriaModule,
        GMapModule,
        GrowlModule,
        InplaceModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        ScheduleModule,
        SelectButtonModule,
        SlideMenuModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        StepsModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        ConfirmDialogModule,
        PrimeNGSharedModule,

        Ng2CompleterModule, //Start 3rd party section
        BusyModule,
        TableModule


    ],
    declarations: [
        CUIAutoCompleteComponent,
        CUIDialogComponent,
        CUIConfirmDialogComponent,
        CUIDetailComponent,
        CUIDetailHeader,
        CUIGridComponent,
        CUIRowGroupComponent,
        CUIRowGroupHeaderComponent,
        CUISearchListComponent,
        CUISpinnerComponent,
        CUITabComponent,
        CUITabContent,
        CUITabHeader,
        CUITabMenuComponent,
        CUITabViewComponent,
        CUIEmptyComponent, //YH 12/1/2016 Task 9542:Revamp Hydrogen Portal left hand side vertical

        //YH 12/28/2016 Task 9829:Hydrogen Portal - User Management: Add/Remove User from Customer UI
        CUIDynamicFormComponent,
        CUIDynamicFormQuestionComponent,
        CUIGridRowActionComponent,
        FormatDatePipe,

        CUIDeviceSettingsComponent,
        CUISingularSettingComponent,


      PowerBiReportContainerComponent,
      WorldViewContainerComponent,
        CuiTurboTableComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AuthorizationModule,

        CUIAutoCompleteComponent,
        CUIDialogComponent,
        CUIConfirmDialogComponent,
        CUIDetailComponent,
        CUIDetailHeader,
        CUIGridComponent,
        CUIRowGroupComponent,
        CUIRowGroupHeaderComponent,
        CUISearchListComponent,
        CUISpinnerComponent,
        CUITabComponent,
        CUITabContent,
        CUITabHeader,
        CUITabMenuComponent,
        CUITabViewComponent,
        CUIEmptyComponent, //YH 12/1/2016 Task 9542:Revamp Hydrogen Portal left hand side vertical

        //YH 12/28/2016 Task 9829:Hydrogen Portal - User Management: Add/Remove User from Customer UI
        CUIDynamicFormComponent,
        CUIDynamicFormQuestionComponent,
        CUIGridRowActionComponent,
        FormatDatePipe,

        CUIDeviceSettingsComponent,
        CUISingularSettingComponent,

      PowerBiReportContainerComponent,
      WorldViewContainerComponent,
        CuiTurboTableComponent
    ],
    providers: [
        ConfirmationService,
        FormatterService,
        //YH 12/28/2016 Task 9829:Hydrogen Portal - User Management: Add/Remove User from Customer UI
        CUIDynamicFormQuestionControlService,
        ActivityLogApiService,
        ScheduledActionsApiService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/shared.module.ts